module.exports = __webpack_public_path__ + "img/shape_orange.8e452e7f.png";